import styled from 'styled-components';

import { ctrlBase, fieldContainer, fieldLabel, fieldMessage } from '../base';

/**
 * The password field.
 *
 * It was the one control the Step 2 pass missed, and it showed: a 54px box
 * with a 10px radius, `#fdfdfd`, a `rgba(182,182,182,.2)` border and 14px
 * text, sitting directly under a `--h-ctrl` email field wearing none of those
 * things. On the login screen — the first screen anyone sees — the two fields
 * in the same form were visibly different objects, 36px against 50px.
 *
 * It now composes `../base` like every other control, so it is the same box
 * as a text input at rest, on hover, on focus, disabled and in error.
 */

export const inputContainer = styled.div`
  ${fieldContainer}
`;

export const Input = styled.input`
  ${ctrlBase}

  /* Room for the reveal button, which sits inside the box. */
  &.has-toggle {
    padding-right: var(--s6);
  }
`;

export const label = styled.label`
  ${fieldLabel}
`;

export const message = styled.span`
  ${fieldMessage}
`;

export const Img = styled.img`
  width: 15px;
  height: 15px;
`;

/**
 * Reveal. A quiet icon button inside the field, on the row's centre line —
 * the same 28px hit area the table's row actions use, so it is a real target
 * without drawing a second border inside the control.
 */
export const ShowHideButton = styled.button`
  position: absolute;
  right: var(--s1);
  top: 0;
  bottom: 0;
  display: grid;
  place-items: center;
  width: var(--h-btn-sm);
  height: var(--h-btn-sm);
  margin: auto 0;
  padding: 0;
  border: none;
  border-radius: var(--r-sm);
  background: none;
  color: var(--text-faint);
  cursor: pointer;
  transition:
    background-color 0.12s,
    color 0.12s;

  &:hover {
    background: var(--surface-alt);
    color: var(--text);
  }
`;

export const InputBox = styled.div`
  position: relative;
`;

export const Grid = styled.div`
  display: flex;
  align-items: center;
  gap: var(--s2);
`;
